import React from "react";
import { withStyles } from "@mui/styles";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

import Label from "../label/Label";

const styles = (theme) => ({
  formControl: {
    width: "100%",
    marginBottom: 10,
  },
  checkboxItems: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "flex-start",
  },
  checkboxItem: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: 10,
  },
  checkboxItemSelect: {
    height: 30,
    width: 30,
    border: "2px solid #3cc77b",
    marginRight: 5,
  },
});

function DropdownSelect({
  classes,
  label,
  value,
  onSelect,
  items,
  placeholder,
}) {
  const handleChange = (event) => {
    onSelect(event.target.value);
  };

  const renderItems = () => {
    return items.map((item) => {
      return (
        <MenuItem key={item.value} value={item.value}>
          {item.label}
        </MenuItem>
      );
    });
  };

  return (
    <FormControl variant="outlined" className={classes.formControl}>
      {label && <Label title={label} />}
      <Select
        labelId="demo-simple-select-outlined-label"
        id="demo-simple-select-outlined"
        value={value}
        onChange={handleChange}
        displayEmpty={placeholder}
      >
        {placeholder && <MenuItem value={null}>{placeholder}</MenuItem>}
        {renderItems()}
      </Select>
    </FormControl>
  );
}

export default withStyles(styles)(DropdownSelect);
